// extracted by mini-css-extract-plugin
export default {"container":"WithTooltip_container__+bl+v","light":"WithTooltip_light__MOTqo"};